
import React from 'react';
import { Outlet } from 'react-router-dom';
import { useIsMobile } from "@/hooks/use-mobile";
import IntellendLogo from "@/components/IntellendLogo";
import * as QRCodeLib from "react-qr-code";
const QRCode = (QRCodeLib as any).QRCode ?? (QRCodeLib as any).default ?? QRCodeLib;

const MobileGuard = () => {
    const isMobile = useIsMobile();
    const currentUrl = window.location.href;

    if (!isMobile) {
        return (
            <div className="fixed inset-0 bg-white flex flex-col justify-center items-center z-[9999]">
                <div className="flex flex-col items-center text-center px-4">
                    <IntellendLogo size="md" />
                    <h1 className="text-2xl font-semibold mt-6 mb-2 text-gray-800">
                        Continue on Your Phone
                    </h1>
                    <p className="text-gray-600 mb-6 max-w-sm">
                        Scan this QR code using your mobile camera to continue securely on your phone.
                    </p>
                    <div className="bg-white p-4 rounded-xl shadow-lg">
                        <QRCode value={currentUrl} size={220} />
                    </div>
                    <p className="text-sm text-gray-500 mt-4">
                        This page can only be accessed from a mobile device.
                    </p>
                </div>
            </div>
        );
    }

    return <Outlet />;
};

export default MobileGuard;
